import { z } from 'zod'
import { ContentfulBadgeSchema, ContentfulCtaSchema } from './components'
import { ContentfulAssetSchema, ContentfulBynderImageSchema } from './asset'
import { ContentfulRichTextDocumentSchema } from './common'

export const ContentfulPageBannerSchema = z.object({
  identifier: z.string(),
  heading: z.string(),
  variant: z.enum(['default', 'centered', 'plectrum']).optional(),
  bodyCopy: ContentfulRichTextDocumentSchema.optional(),
  imagePosition: z.enum(['right', 'left']).optional(),
  image: ContentfulAssetSchema.optional(),
  bynderImage: z.array(ContentfulBynderImageSchema).optional(),
  badge: ContentfulBadgeSchema.optional(),
  ctaPrimary: ContentfulCtaSchema.optional(),
  ctaSecondary: ContentfulCtaSchema.optional(),
  entryId: z.string().optional(),
  revisionId: z.number().optional(),
  contentType: z.literal('component-banner'),
})

export type ContentfulPageBanner = z.infer<typeof ContentfulPageBannerSchema>
